// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-list-concierge-title {
  padding-top: var(--spacing-extra-big);
}
.list-concierge-title {
  font-size: var(--font-big);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.container-title-breadcrumb {
  padding-top: var(--spacing-small);
  padding-bottom: var(--spacing-extra-big);
}
.text-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.container-buttons {
  padding-top: var(--spacing-extra-big);
}
.text-not-found {
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-giant);
}
.span-button-cadastrar {
  color: var(--color-button-text);
}
.span-button-historico {
  color: var(--color-detached);
}
.cell-status {
  margin-left: var(--spacing-small);
}
.container-details {
  width: 12vh;
}
.icon-details {
  margin-left: var(--spacing-extra-small);
}
.container-table {
  overflow-x: auto;
  margin-top: var(--spacing-small);
}
.details-card-title {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.details-card-subtitle {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-dark-darker);
}
.product-rejected {
  text-decoration: line-through;
}
.details-card-text {
  font-weight: 500;
}
.address-divider {
  border-bottom-color: var(--color-neutral-light);
  border-bottom-width: 1px;
  border-bottom-style: solid;
  width: 80%;
  margin-top: var(--spacing-extra-small);
  margin-bottom: var(--spacing-extra-small);
}
.solicitation-status-title {
  margin-right: var(--spacing-extra-small);
}
.span-status-date {
  font-size: var(--font-medium-line);
  font-weight: 500;
  color: var(--color-neutral-dark);
  margin-top: -5px;
}
.span-status-description {
  font-size: var(--font-small);
  font-weight: 400;
  color: var(--color-neutral-dark-lighter);
}
@media (max-width: 768px) {
  .select-category {
    margin-top: var(--spacing-big);
  }
}
.select-category .ant-select-selection-placeholder {
  font-weight: 400 !important;
}
.table-concierge .ant-table-expanded-row {
  background-color: var(--color-white);
}
.table-concierge .ant-table-expanded-row .ant-table-cell {
  background-color: var(--color-white);
}
.table-concierge .ant-table-expanded-row:hover .ant-table-cell {
  background-color: var(--color-white);
}
.table-products-new-solicitation .ant-table-container {
  border-top: 1px solid var(--border-color-table) !important;
}
.container-details-card {
  background-color: var(--color-white);
}
.margin-top-extra-small {
  margin-top: var(--spacing-extra-small);
}
.margin-top-small {
  margin-top: var(--spacing-small);
}
.margin-top-regular {
  margin-top: var(--spacing-regular);
}
.margin-right-small {
  margin-right: var(--spacing-small);
}
.margin-right-extra-small {
  margin-right: var(--spacing-extra-small);
}
.margin-top-big {
  margin-top: var(--spacing-big);
}
.container-favorite-supplier {
  display: flex;
  flex-direction: column;
}
.container-addresses-main {
  background-color: var(--color-neutral-light-lighter);
  margin-top: var(--spacing-small);
}
.container-addresses-sub {
  padding: var(--spacing-small);
}
.container-address-billing {
  padding-left: var(--spacing-small);
  border-left: 1px solid var(--color-neutral-light);
  display: flex;
  flex-direction: column;
}
@media (max-width: 576px) {
  .container-address-billing {
    border-right: none;
  }
}
.container-address-shipping {
  padding-left: var(--spacing-small);
  border-left: 1px solid var(--color-neutral-light);
  display: flex;
  flex-direction: column;
}
.address-shipping-subtitle {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-dark-darker);
  margin-bottom: var(--spacing-extra-small);
  margin-top: var(--spacing-extra-small);
}
.container-info-steps-solicition {
  margin-top: var(--spacing-regular);
  background-color: var(--color-neutral-light-lighter);
  padding: var(--spacing-regular) var(--spacing-small);
}
.info-steps-solicition-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.info-steps-solicition-subtitle {
  font-size: var(--spacing-small);
  font-weight: 400;
  color: var(--color-neutral-dark-darker);
}
.info-steps-solicition-number {
  font-size: var(--font-giant);
  font-weight: 400;
  color: var(--colorTextBase);
  margin-right: var(--spacing-small);
}
.info-steps-solicition-description {
  font-size: var(--font-medium);
  font-weight: 400;
  color: var(--colorTextBase);
}
.button-manage-solicitation {
  padding: var(--spacing-extra-small) !important;
}
.container-empty-list-solicitation {
  padding-top: var(--spacing-extra-big);
}
.details-button-text {
  font-weight: 500;
  color: var(--color-highlight);
  margin-right: var(--font-medium);
}
.container-summary-product {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: var(--border-radius-base);
  padding: var(--spacing-small) !important;
}
.container-banner-list-concierge {
  margin-top: var(--spacing-regular);
  width: 100%;
}
.loading-container {
  height: 170px;
  padding-top: var(--spacing-extra-big);
  display: flex;
  justify-content: center;
  align-items: center;
}
.align-items-center {
  display: flex;
  align-items: center;
}
.concierge-solicitation-not-found {
  margin-top: var(--spacing-regular);
}
@media screen and (max-width: 768px) {
  .span-button-concierge-list {
    font-size: var(--font-small);
  }
  .text-not-found {
    font-size: var(--font-medium) !important;
  }
  .button-concierge-list {
    padding-left: var(--spacing-small) !important;
    padding-right: var(--spacing-small) !important;
  }
}
@media screen and (max-width: 1400px) {
  span {
    font-size: var(--font-small);
  }
}
@media screen and (max-width: 1080px) {
  .table-concierge th,
  .table-concierge td,
  .table-concierge .span-cell-content {
    font-size: var(--font-small);
  }
  .table-concierge .ant-table-expanded-row {
    background-color: var(--color-white);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/concierge/ListConciergeStyles.less"],"names":[],"mappings":"AACA;EACI,qCAAA;AAAJ;AAGA;EACI,0BAAA;EACA,gBAAA;EACA,gCAAA;AADJ;AAIA;EACI,iCAAA;EACA,wCAAA;AAFJ;AAKA;EACI,4BAAA;EACA,gBAAA;EACA,gCAAA;AAHJ;AAMA;EACI,qCAAA;AAJJ;AAOA;EACI,wCAAA;EACA,4BAAA;AALJ;AAQA;EACI,+BAAA;AANJ;AASA;EACI,4BAAA;AAPJ;AAUA;EACI,iCAAA;AARJ;AAWA;EACI,WAAA;AATJ;AAYA;EACI,uCAAA;AAVJ;AAaA;EACI,gBAAA;EACA,gCAAA;AAXJ;AAcA;EACI,6BAAA;EACA,gBAAA;EACA,uCAAA;AAZJ;AAeA;EACI,gCAAA;EACA,gBAAA;EACA,uCAAA;AAbJ;AAgBA;EACI,6BAAA;AAdJ;AAiBA;EACI,gBAAA;AAfJ;AAkBA;EACI,+CAAA;EACA,wBAAA;EACA,0BAAA;EACA,UAAA;EACA,sCAAA;EACA,yCAAA;AAhBJ;AAmBA;EACI,wCAAA;AAjBJ;AAoBA;EACI,kCAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;AAlBJ;AAqBA;EACI,4BAAA;EACA,gBAAA;EACA,wCAAA;AAnBJ;AAuBI;EAAA;IACI,8BAAA;EApBN;AACF;AAuBA;EACI,2BAAA;AArBJ;AAwBA;EAEQ,oCAAA;AAvBR;AAqBA;EAKY,oCAAA;AAvBZ;AAkBA;EAWY,oCAAA;AA1BZ;AA+BA;EAEQ,0DAAA;AA9BR;AAkCA;EACI,oCAAA;AAhCJ;AAmCA;EACI,sCAAA;AAjCJ;AAoCA;EACI,gCAAA;AAlCJ;AAqCA;EACI,kCAAA;AAnCJ;AAsCA;EACI,kCAAA;AApCJ;AAuCA;EACI,wCAAA;AArCJ;AAwCA;EACI,8BAAA;AAtCJ;AAyCA;EACI,aAAA;EACA,sBAAA;AAvCJ;AA0CA;EACI,oDAAA;EACA,gCAAA;AAxCJ;AA2CA;EACI,6BAAA;AAzCJ;AA4CA;EACI,kCAAA;EACA,iDAAA;EAEA,aAAA;EACA,sBAAA;AA3CJ;AA6CI;EAAA;IACI,kBAAA;EA1CN;AACF;AA6CA;EACI,kCAAA;EACA,iDAAA;EAEA,aAAA;EACA,sBAAA;AA5CJ;AA+CA;EACI,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,yCAAA;EACA,sCAAA;AA7CJ;AAgDA;EACI,kCAAA;EACA,oDAAA;EACA,oDAAA;AA9CJ;AAiDA;EACI,4BAAA;EACA,gBAAA;EACA,uCAAA;AA/CJ;AAkDA;EACI,+BAAA;EACA,gBAAA;EACA,uCAAA;AAhDJ;AAmDA;EACI,4BAAA;EACA,gBAAA;EACA,2BAAA;EACA,kCAAA;AAjDJ;AAoDA;EACI,6BAAA;EACA,gBAAA;EACA,2BAAA;AAlDJ;AAqDA;EACI,8CAAA;AAnDJ;AAsDA;EACI,qCAAA;AApDJ;AAuDA;EACI,gBAAA;EACA,6BAAA;EACA,gCAAA;AArDJ;AAwDA;EACI,+CAAA;EACA,wCAAA;EACA,wCAAA;AAtDJ;AAyDA;EACI,kCAAA;EACA,WAAA;AAvDJ;AA0DA;EACI,aAAA;EACA,qCAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzDJ;AA4DA;EACI,aAAA;EACA,mBAAA;AA1DJ;AA6DA;EACI,kCAAA;AA3DJ;AA+DA;EACI;IACI,4BAAA;EA7DN;EAgEE;IACI,wCAAA;EA9DN;EAiEE;IACI,6CAAA;IACA,8CAAA;EA/DN;AACF;AAkEA;EACI;IACI,4BAAA;EAhEN;AACF;AAmEA;EACI;;;IAKQ,4BAAA;EAnEV;EA8DE;IASQ,oCAAA;EApEV;AACF","sourcesContent":["//DESKTOP\n.container-list-concierge-title {\n    padding-top: var(--spacing-extra-big);\n}\n\n.list-concierge-title {\n    font-size: var(--font-big);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n}\n\n.container-title-breadcrumb {\n    padding-top: var(--spacing-small);\n    padding-bottom: var(--spacing-extra-big);\n}\n\n.text-title {\n    font-size: var(--font-giant);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n}\n\n.container-buttons {\n    padding-top: var(--spacing-extra-big);\n}\n\n.text-not-found {\n    color: var(--color-neutral-dark-lighter);\n    font-size: var(--font-giant);\n}\n\n.span-button-cadastrar {\n    color: var(--color-button-text);\n}\n\n.span-button-historico {\n    color: var(--color-detached);\n}\n\n.cell-status {\n    margin-left: var(--spacing-small);\n}\n\n.container-details {\n    width: 12vh;\n}\n\n.icon-details {\n    margin-left: var(--spacing-extra-small);\n}\n\n.container-table {\n    overflow-x: auto;\n    margin-top: var(--spacing-small);\n}\n\n.details-card-title {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.details-card-subtitle {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    color: var(--color-neutral-dark-darker);\n}\n\n.product-rejected {\n    text-decoration: line-through;\n}\n\n.details-card-text {\n    font-weight: 500;\n}\n\n.address-divider {\n    border-bottom-color: var(--color-neutral-light);\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    width: 80%;\n    margin-top: var(--spacing-extra-small);\n    margin-bottom: var(--spacing-extra-small);\n}\n\n.solicitation-status-title {\n    margin-right: var(--spacing-extra-small);\n}\n\n.span-status-date {\n    font-size: var(--font-medium-line);\n    font-weight: 500;\n    color: var(--color-neutral-dark);\n    margin-top: -5px;\n}\n\n.span-status-description {\n    font-size: var(--font-small);\n    font-weight: 400;\n    color: var(--color-neutral-dark-lighter);\n}\n\n.select-category {\n    @media (max-width: 768px) {\n        margin-top: var(--spacing-big);\n    }\n}\n\n.select-category .ant-select-selection-placeholder {\n    font-weight: 400 !important;\n}\n\n.table-concierge {\n    .ant-table-expanded-row {\n        background-color: var(--color-white);\n\n        .ant-table-cell {\n            background-color: var(--color-white);\n        }\n    }\n\n    .ant-table-expanded-row:hover {\n        .ant-table-cell {\n            background-color: var(--color-white);\n        }\n    }\n}\n\n.table-products-new-solicitation {\n    .ant-table-container {\n        border-top: 1px solid var(--border-color-table) !important;\n    }\n}\n\n.container-details-card {\n    background-color: var(--color-white);\n}\n\n.margin-top-extra-small {\n    margin-top: var(--spacing-extra-small);\n}\n\n.margin-top-small {\n    margin-top: var(--spacing-small);\n}\n\n.margin-top-regular {\n    margin-top: var(--spacing-regular);\n}\n\n.margin-right-small {\n    margin-right: var(--spacing-small);\n}\n\n.margin-right-extra-small {\n    margin-right: var(--spacing-extra-small);\n}\n\n.margin-top-big {\n    margin-top: var(--spacing-big);\n}\n\n.container-favorite-supplier {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-addresses-main {\n    background-color: var(--color-neutral-light-lighter);\n    margin-top: var(--spacing-small);\n}\n\n.container-addresses-sub {\n    padding: var(--spacing-small);\n}\n\n.container-address-billing {\n    padding-left: var(--spacing-small);\n    border-left: 1px solid var(--color-neutral-light);\n\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 576px) {\n        border-right: none;\n    }\n}\n\n.container-address-shipping {\n    padding-left: var(--spacing-small);\n    border-left: 1px solid var(--color-neutral-light);\n\n    display: flex;\n    flex-direction: column;\n}\n\n.address-shipping-subtitle {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    color: var(--color-neutral-dark-darker);\n    margin-bottom: var(--spacing-extra-small);\n    margin-top: var(--spacing-extra-small);\n}\n\n.container-info-steps-solicition {\n    margin-top: var(--spacing-regular);\n    background-color: var(--color-neutral-light-lighter);\n    padding: var(--spacing-regular) var(--spacing-small);\n}\n\n.info-steps-solicition-title {\n    font-size: var(--font-giant);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.info-steps-solicition-subtitle {\n    font-size: var(--spacing-small);\n    font-weight: 400;\n    color: var(--color-neutral-dark-darker);\n}\n\n.info-steps-solicition-number {\n    font-size: var(--font-giant);\n    font-weight: 400;\n    color: var(--colorTextBase);\n    margin-right: var(--spacing-small);\n}\n\n.info-steps-solicition-description {\n    font-size: var(--font-medium);\n    font-weight: 400;\n    color: var(--colorTextBase);\n}\n\n.button-manage-solicitation {\n    padding: var(--spacing-extra-small) !important;\n}\n\n.container-empty-list-solicitation {\n    padding-top: var(--spacing-extra-big);\n}\n\n.details-button-text {\n    font-weight: 500;\n    color: var(--color-highlight);\n    margin-right: var(--font-medium);\n}\n\n.container-summary-product {\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n    border-radius: var(--border-radius-base);\n    padding: var(--spacing-small) !important;\n}\n\n.container-banner-list-concierge {\n    margin-top: var(--spacing-regular);\n    width: 100%;\n}\n\n.loading-container {\n    height: 170px;\n    padding-top: var(--spacing-extra-big);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.align-items-center {\n    display: flex;\n    align-items: center;\n}\n\n.concierge-solicitation-not-found {\n    margin-top: var(--spacing-regular);\n}\n\n//MOBILE\n@media screen and (max-width: 768px) {\n    .span-button-concierge-list {\n        font-size: var(--font-small);\n    }\n\n    .text-not-found {\n        font-size: var(--font-medium) !important;\n    }\n\n    .button-concierge-list {\n        padding-left: var(--spacing-small) !important;\n        padding-right: var(--spacing-small) !important;\n    }\n}\n\n@media screen and (max-width: 1400px) {\n    span {\n        font-size: var(--font-small);\n    }\n}\n\n@media screen and (max-width: 1080px) {\n    .table-concierge {\n\n        th,\n        td,\n        .span-cell-content {\n            font-size: var(--font-small);\n        }\n\n        .ant-table-expanded-row {\n            background-color: var(--color-white);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
